<template>
  <div>
    <Head :title="title" />
    <div class="bg-white rounded-md shadow overflow-hidden w-full">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.code" :error="form.errors.code" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Code Asset')" readonly />
          <text-input v-model="form.category" :error="form.errors.category" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Category')" readonly />
          <text-input v-model="form.type" :error="form.errors.type" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Type')" readonly />
          <text-input v-model="form.serial_number" :error="form.errors.serial_number" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Serial Number')" readonly />
          <text-input v-model="form.brand" :error="form.errors.brand" type="text" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Brand')" readonly />
          <text-input v-model="form.join_date" :error="form.errors.join_date" type="date" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Join Date')" readonly />
          <textarea-input v-model="form.specification" :error="form.errors.specification" :rows="4" class="pb-6 w-full" placeholder="specifcation here.." :label="__('Specification')" readonly></textarea-input>

          <div class="pr-6 pb-8 w-full">
            <label class="form-label mb-6">{{ __('Service') }}:</label>
            <div v-for="(service, index) in form.services" :key="index" class="flex space-x-4 mb-4">
              <text-input v-model="service.name" :error="form.errors[`services.${index}.name`]" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Service Name')" />
              <textarea-input v-model="service.detail" :error="form.errors[`services.${index}.detail`]" :rows="4" class="pb-6 w-1/2" placeholder="detail here..." :label="__('Detail Service')"></textarea-input>
              <button type="button" @click="removeDetail(index)" class="text-red-500 ml-4">
                {{ __('Remove') }}
              </button>
            </div>
            <button type="button" @click="addDetail" class="text-blue-500">
              {{ __('Add service') }}
            </button>
          </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">{{ __('Create Service') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

  <script>
import Layout from '@/Shared/Layout'
import { Head } from '@inertiajs/vue3'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    LoadingButton,
    TextInput,
    TextareaInput,
    Head,
  },
  layout: Layout,
  props: {
    title: String,
    asset: Object,
    services: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        code: this.asset.code,
        category: this.asset.category,
        type: this.asset.type,
        serial_number: this.asset.serial_number,
        brand: this.asset.brand,
        join_date: this.asset.join_date,
        specification: this.asset.specification,
        services: this.services.length
          ? this.services.map((service) => ({
              name: service.name,
              detail: service.detail,
            }))
          : [{ name: '', detail: '' }],
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('assets.service_store', this.asset.id))
    },
    addDetail() {
      this.form.services.push({ name: '', detail: '' })
    },
    removeDetail(index) {
      this.form.services.splice(index, 1)
    },
  },
}
</script>
